import { Injectable } from '@angular/core';
import { ErrorResponse } from "angular2-jsonapi";
import { NotificationsService } from "angular2-notifications";

@Injectable()
export class ErrorMessageService {

  constructor(
    private notificationService: NotificationsService
  ) { }

  public notify(error: any) {
    this.notificationService.error("Fehler aufgetreten", ErrorMessageService.build(error))
  }

  public static build(error: any) {
    if (error instanceof ErrorResponse) {
      return error.errors.map(error => error.title).join("\n")
    } else if (error instanceof String) {
      return error;
    } else {
      return "unkown error message"
    }
  }

  public static buildDetailed(error: any) {
    if (error instanceof ErrorResponse) {
      return error.errors.map(error => error.title + ": " + error.detail).join("\n")
    } else if (error instanceof String) {
      return error;
    } else {
      return "unkown error message"
    }
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/error-message.service.ts